import React from 'react';

import { Apelido, ComoConheceu, Cpf, DataNascimento, Escolaridade, EstadoCivil, Filhos, Nome, Profissao, Sexo } from '../../../paginas/Formulario/Dados';
import { Celular, Email } from '../../../paginas/Formulario/Contatos';
import { Endereco, EnderecoSimples } from '../../../paginas/Formulario/Endereco';
import { TermoEscola } from '../../../paginas/Formulario/Termos';
import { EscolhaDeVoluntariado } from '../../../paginas/Formulario/Voluntario';

export function formataEtapas(etapas: any) {
  const etapasCustomizadas = { inscricao: [] as any[], posInscricao: [] as any[] }
  function adicionar(chave: 'inscricao' | 'posInscricao', etapa: { path: string, render: () => JSX.Element }) {
    etapasCustomizadas[chave].push(etapa);
  }

  // CPF sempre primeiro, caso possamos buscar os dados da pessoas no sistema
  if (/^inscricao-(padrao|com-cpf)$/.test(etapas.cpf))
    adicionar('inscricao', { path: '/formulario/dados/cpf', render: () => <Cpf /> })

  // Nome, celular e email são os dados principais
  if (etapas.nome) adicionar('inscricao', { path: '/formulario/dados/nome', render: () => <Nome /> })

  // Caso tenha etapa apelido, vem depois do nome
  if (etapas.apelido) adicionar('inscricao', { path: '/formulario/dados/apelido', render: () => <Apelido /> })

  // Informações de contato
  if (etapas.celular) adicionar('inscricao', { path: '/formulario/contatos/celular', render: () => <Celular /> })

  if (/^(obrigatorio|simples)$/.test(etapas.email))
    adicionar('inscricao', { path: '/formulario/contatos/email', render: () => <Email obrigatorio={etapas.email === 'obrigatorio'} /> })

  // Informações pessoais
  if (etapas.data_nascimento)
    adicionar('inscricao', { path: '/formulario/dados/data-nascimento', render: () => <DataNascimento /> })

  if (etapas.sexo) adicionar('inscricao', { path: '/formulario/dados/sexo', render: () => <Sexo /> })

  // Informações familiares
  if (etapas.estado_civil) adicionar('inscricao', { path: '/formulario/dados/estado-civil', render: () => <EstadoCivil /> })

  if (etapas.filhos) adicionar('inscricao', { path: '/formulario/dados/filhos', render: () => <Filhos /> })

  // Informações profissionais
  if (etapas.escolaridade) adicionar('inscricao', { path: '/formulario/dados/escolaridade', render: () => <Escolaridade /> })

  if (etapas.profissao) adicionar('inscricao', { path: '/formulario/dados/profissao', render: () => <Profissao /> })

  // Endereco por ultimo, etapa mais complexa
  if (etapas.endereco)
    adicionar(
      'inscricao',
      {
        path: '/formulario/endereco',
        render: etapas.endereco === 'completo' ? () => <Endereco /> : () => <EnderecoSimples />
      }
    )

  // Etapa de feedback
  if (etapas.como_conheceu) adicionar('inscricao', { path: '/formulario/como-conheceu', render: () => <ComoConheceu /> })

  // Configuração de termos
  if (etapas.termos.find((t: any) => t.idTermoTipo === 8))
    adicionar('inscricao', {path: '/formulario/termo-adesao', render: () => <TermoEscola schema="libcom" />})

  // Etapas de continuação
  if (etapas.voluntariados && etapas.voluntariados.length)
    adicionar(
      'posInscricao',
      {
        path: '/formulario/escolha-voluntariado',
        render: () => <EscolhaDeVoluntariado perfis={etapas.voluntariados} />
      }
    )

  return etapasCustomizadas
}